import React from 'react';
import Migration from './Migration';
export default function MigrationBucket() {
    return <Migration url={'bucket'} />
};
